module.exports = __webpack_public_path__ + "img/ph-success.f51ed16c.png";